// extracted by mini-css-extract-plugin
export default {"BlogPage":"style_BlogPage__D62Ta"};